function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRecoverv2 = function SvgRecoverv2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_-outline-expand",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    height: 3.333,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.536 -0.8442 0.8442 0.536 -29.1637 52.2029)",
    width: 2,
    x: 31.906,
    y: 50.965
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.979,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.2071 -0.9783 0.9783 0.2071 -30.5351 70.8548)",
    width: 2,
    x: 27.445,
    y: 51.776
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    width: 5.625,
    x: 24,
    y: 55.499
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.9783 -0.207 0.207 0.9783 -11.5415 7.1601)",
    width: 4.979,
    x: 25.956,
    y: 57.734
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.001,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.8443 -0.5359 0.5359 0.8443 -27.2264 27.0323)",
    width: 3.332,
    x: 31.24,
    y: 59.369
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.063,
    style: {
      fill: "#EFBC2E"
    },
    width: 2,
    x: 38,
    y: 59.937
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3.331,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.5359 -0.8443 0.8443 0.5359 -30.0405 66.0901)",
    width: 2.001,
    x: 44.093,
    y: 58.704
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.979,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.2069 -0.9784 0.9784 0.2069 -18.1623 95.0622)",
    width: 2,
    x: 48.555,
    y: 56.244
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    width: 5.625,
    x: 48.375,
    y: 55.499
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.9783 -0.207 0.207 0.9783 -10.1594 11.4328)",
    width: 4.979,
    x: 47.065,
    y: 53.265
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.999,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.844 -0.5363 0.5363 0.844 -21.1924 32.3932)",
    width: 3.332,
    x: 43.428,
    y: 51.631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,56.5c0,2.485-4.925,4.5-11,4.5c-6.075,0-11-2.015-11-4.5S32.925,52,39,52  C45.075,52,50,54.014,50,56.5L50,56.5z",
    style: {
      fill: "#42A5B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,20c0,2.762,2.238,5,5,5c2.762,0,5-2.238,5-5c0-2.762-2.238-5-5-5C19.238,15,17,17.238,17,20  L17,20z",
    style: {
      fill: "#62C4C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,40.059l-4,2l-2.966-6.675c-0.631-1.419-0.384-3.075,0.635-4.247L15,24.999h17l6-6l3,3l-7,7h-7  v9.06l10,2l4,12l-4,1l-3-8l-11-2l-2,17.94h-5l1-19.94v-11l-4,4L16,40.059z",
    style: {
      fill: "#62C4C3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38,13 38,3 49,8 ",
    style: {
      fill: "#D36767"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 17.001,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 37,
    y: 2.999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.891,24.832C23.188,24.356,22,22.78,22,20.999h2c0,0.888,0.588,1.672,1.43,1.907L24.891,24.832z",
    style: {
      fill: "#3A4249"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecoverv2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recoverv2.923cbb49.svg";
export { ForwardRef as ReactComponent };